import React, { useEffect, useState } from "react";
import { Box, Button, ButtonGroup, CardCover, Divider, Grid, IconButton, Sheet, ToggleButtonGroup, Typography } from "@mui/joy";
import UndoRoundedIcon from '@mui/icons-material/UndoRounded';
import RedoRoundedIcon from '@mui/icons-material/RedoRounded';
import FormatBoldRoundedIcon from '@mui/icons-material/FormatBoldRounded';
import FormatItalicRoundedIcon from '@mui/icons-material/FormatItalicRounded';
import FormatUnderlinedRoundedIcon from '@mui/icons-material/FormatUnderlinedRounded';
import FormatStrikethroughRoundedIcon from '@mui/icons-material/FormatStrikethroughRounded';
import StrikethroughSRoundedIcon from '@mui/icons-material/StrikethroughSRounded';
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import FormatIndentIncreaseRoundedIcon from '@mui/icons-material/FormatIndentIncreaseRounded';
import FormatIndentDecreaseRoundedIcon from '@mui/icons-material/FormatIndentDecreaseRounded';

// import { Color } from '@tiptap/extension-color';
import { EditorContent, EditorProvider, useCurrentEditor, useEditor } from '@tiptap/react';
import Underline from '@tiptap/extension-underline';
import TextStyle from '@tiptap/extension-text-style';
import Link from '@tiptap/extension-link';
import ListItem from '@tiptap/extension-list-item';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import { RichTextToolbar } from "./RichTextToolbar";
import { useDebounce } from "@uidotdev/usehooks";

const extensions = [
  Placeholder.configure({
      // Use a placeholder:
      placeholder: 'Write something …',
      // Use different placeholders depending on the node type:
      // placeholder: ({ node }) => {
      //   if (node.type.name === 'heading') {
      //     return 'What’s the title?'
      //   }

      //   return 'Can you add some further context?'
      // },
  }),
  // Color.configure({ types: [TextStyle.name, ListItem.name] }),
  Underline,
  TextStyle.configure({ types: [ListItem.name] }),
  Link.configure({
    openOnClick: false,
    autolink: true,
  }),
  StarterKit.configure({
    bulletList: {
      keepMarks: true,
      keepAttributes: false,
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false,
    },
  }),
]

export function RichTextEditor({ initialContent = '', onChange, menu = 'default' }) {
  const [content, setContent] = useState(initialContent);
  let debouncedContent = useDebounce(content, 150); // prevent too many events

  const editor = useEditor({
    extensions: extensions,
    content: initialContent,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      // console.log(html);
      setContent(html);
    },
  });

  // this is required to make sure the content loads correctly; if the attribute comes across as null, tiptap won't update without this
  useEffect(() => {
    if(initialContent && !content) {
      editor.commands.setContent(initialContent);
      // return false;
    }
  }, [initialContent]);

  useEffect(() => {
    try {
      // if(content === '' && debouncedContent !== '') {
      console.log('content was updated', debouncedContent);
      onChange(debouncedContent);
      // }
    } catch(e) {
      //
    }
  }, [debouncedContent]);

  return (<>
    <RichTextToolbar editor={editor} menu={menu} />
    <EditorContent editor={editor} />
  </>);

/*
  return (
    <EditorProvider
        // editorProps={{}}
        slotBefore={<RichTextToolbar menu={menu} />}
        extensions={extensions}
        content={initialContent ?? ''}
        onUpdate={({ editor }) => {
          const html = editor.getHTML();
          // console.log(html);
          setContent(html);
        }}
    >
    </EditorProvider>
  );
  */
}
